const clampProgress = (progress) => {
  const numericProgress = Number(progress);

  if (Number.isNaN(numericProgress)) {
    return 0;
  }

  return Math.min(Math.max(numericProgress, 0), 100);
};

const ComputingPreloader = ({ message, progress }) => {
  const safeProgress = clampProgress(progress);

  return (
    <div className="soe-loader-outer">
      <style>
        {`
          .soe-loader-outer {
            align-items: center;
            display: flex;
            justify-content: center;
            min-height: 140px;
            padding-bottom: 10px;
          }

          .loader-wrap {
            align-items: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 380px;
          }

          .loader-pct {
            color: #2e8b3a;
            font-family: 'DM Mono', monospace;
            font-size: 1.25rem;
            font-weight: 500;
            letter-spacing: 3px;
            margin-bottom: 0;
          }

          .bar-wrap {
            margin-top: 0;
            width: 100%;
          }

          .bar-track {
            background: #e4e4e0;
            border-radius: 99px;
            height: 8px;
            overflow: hidden;
            position: relative;
            width: 100%;
          }

          .bar-fill {
            animation: shimmerShift 1.8s ease-in-out infinite;
            background: linear-gradient(
              90deg,
              #1e6b28,
              #2e8b3a,
              #4db85a,
              #2e8b3a
            );
            background-size: 200% 100%;
            border-radius: 99px;
            height: 100%;
            overflow: hidden;
            position: relative;
            transition: width 0.3s ease;
          }

          .bar-fill::after {
            animation: lightSweep 1.4s linear infinite;
            background: linear-gradient(
              90deg,
              transparent 0%,
              rgba(255, 255, 255, 0.15) 40%,
              rgba(255, 255, 255, 0.75) 50%,
              rgba(255, 255, 255, 0.15) 60%,
              transparent 100%
            );
            content: '';
            height: 100%;
            left: -60%;
            position: absolute;
            top: 0;
            width: 60%;
          }

          .loader-status {
            font-size: 0.9rem;
            font-weight: 500;
            letter-spacing: 0.5px;
            margin-top: 4px;
            white-space: nowrap;
          }

          .loader-status span {
            animation: textThink 2.4s linear infinite;
            background: linear-gradient(
              90deg,
              #444 0%,
              #444 30%,
              #2e8b3a 50%,
              #444 70%,
              #444 100%
            );
            background-size: 250% 100%;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            display: inline-block;
          }

          @keyframes shimmerShift {
            0% {
              background-position: 100% 0;
            }

            100% {
              background-position: -100% 0;
            }
          }

          @keyframes lightSweep {
            0% {
              left: -60%;
            }

            100% {
              left: 110%;
            }
          }

          @keyframes textThink {
            0% {
              background-position: 150% 0;
            }

            100% {
              background-position: -150% 0;
            }
          }

          .loader-dots {
            display: flex;
            gap: 6px;
            justify-content: center;
            margin-bottom: 2px;
            margin-top: 8px;
          }

          .loader-dots span {
            animation: dotPulse 1.2s ease-in-out infinite;
            background: #2e8b3a;
            border-radius: 50%;
            display: inline-block;
            height: 6px;
            opacity: 0.25;
            width: 6px;
          }

          .loader-dots span:nth-child(2) {
            animation-delay: 0.2s;
          }

          .loader-dots span:nth-child(3) {
            animation-delay: 0.4s;
          }

          @keyframes dotPulse {
            0%,
            100% {
              opacity: 0.25;
              transform: scale(1);
            }

            50% {
              opacity: 1;
              transform: scale(1.5);
            }
          }
        `}
      </style>
      <div className="loader-wrap">
        <div className="loader-pct">{safeProgress}%</div>
        <div className="bar-wrap">
          <div className="bar-track">
            <div className="bar-fill" style={{ width: `${safeProgress}%` }} />
          </div>
        </div>
        <div className="loader-dots">
          <span />
          <span />
          <span />
        </div>
        <div className="loader-status">
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
};

export default ComputingPreloader;
